module.exports = __webpack_public_path__ + "static/img/yinliangjia.3e9e123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/yinliangjia.png
// module id = 2A/e
// module chunks = 24